<template>
  <!-- 首页 -->
  <div class="page">
    <div class="banner">
      <img src="../assets/baner.png" alt="" />
    </div>
    <div class="content">
      <!-- <div class="title">功能管理</div> -->
      <div>
        <!-- <div class="option">
          <div class="info">
            <img src="../assets/list1.png" alt="" />
            <p>投标保证保险</p>
            <el-button size="small" type="primary" @click="help">
              点击申请
            </el-button>
          </div>
          <div class="info">
            <img src="../assets/list2.png" alt="" />
            <p>履约保证保险</p>
            <el-button size="small" type="primary">
              点击申请
            </el-button>
          </div>
          <div class="info">
            <img src="../assets/list3.png" alt="" />
            <p>预付款保证保险</p>
            <el-button size="small" type="primary" >
              点击申请
            </el-button>
          </div>
          <div class="info">
            <img src="../assets/list4.png" alt="" />
            <p>农名工工资保证保险</p>
            <el-button size="small" type="primary" >
              点击申请
            </el-button>
          </div>
        </div> -->
        <div class="footer">
          <div class="text">
            <p>申请说明:</p>
            <p>1、您可以通过上传招标文件、营业执照等，即可实现保险保函的办理</p>
            <p>
              2、在订单管理板块中显示您的保险保函申请记录，并可对已开具保函的订单发起退保申请.
            </p>
            <p>3、在发票管理板块中可对已出具保函的订单提交发票申请操作</p>
            <p>
              4、更多问题可直接咨询客服电话400-003-1733，或扫描下方二维码进行咨询
            </p>
          </div>
          <div class="img">
            <img src="../assets/login/code.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="请选择申请模式"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <div class="pop">
        <div class="tab" @click="selfHelp">
          <img src="../assets/list5.png" alt="" />
          <p class="self">自助申请</p>
          <p>
            上传招标文件、营业执照，并完成基本的订单信息即可实现保险保函的办理，最快1小时内可开具保单保函;
          </p>
        </div>
        <div class="tab">
          <img src="../assets/list6.png" alt="" />
          <p class="self">自主申请</p>
          <p>
            乾保网会实时更新各交易中心项目信息，您只需在列表中找到您要办理保险保函的项目,即可快速完成申请流程，最快2小时内可开具保单保函。
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    application() {
      this.$router.push("/application");
    },
    help() {
      this.dialogVisible = true;
    },
    selfHelp() {
      this.$router.push("/selfHelp");
    },
  },
  components: {},
};
</script>

<style lang="less" scoped>
.page {
  height: 100%;
  font-size: 16PX;
  font-family: none;
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .content {
    margin-top: 15PX;
    padding: 15PX 35PX;
    background-color: #ffffff;
    overflow-y: hidden;
    .option {
      display: flex;
      justify-content: space-around;
    }
    .footer {
      .text {
        margin-top: 50PX;
        width: 100%;
        text-align: center;
        p:first-child {
          font-weight: bold;
          margin-bottom: 25PX;
        }
        p {
          margin-top: 7PX;
        }
      }
      .img {
        display: flex;
        justify-content: center;
        margin-top: 20PX;
        img{
          width: 120PX;
        }
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 30PX 80PX;
      background-color: #f6f7fc;
      p {
        margin: 15PX 0;
        font-weight: bold;
      }
    }
  }
}
.pop {
  display: flex;

  .tab {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding: 20PX 30PX;
    color: #b5b5b5;
    cursor: pointer;
    .self {
      font-size: 20PX;
      font-weight: bold;
      color: #000000;
      margin: 20PX 0;
    }
  }
}

::v-deep .el-dialog__title {
  border-left: 5PX solid #3b7df9;
  padding-left: 10PX;
  font-weight: bold;
}
</style>
